import { render, staticRenderFns } from "./SingleInvoices.vue?vue&type=template&id=12279bca"
import script from "./SingleInvoices.vue?vue&type=script&lang=js"
export * from "./SingleInvoices.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports